import { WithSelect } from '@components/design';
import React from 'react';

import { ComparisonGrowth } from '@services/FiltersTypes';

import { useAnalytics } from '@ecosystem/newron-client-lib';
import { useSelector } from 'react-redux';
import { FilterType } from '@utils/page-analytics/model/AnalyticTrackingBasePropertiesObj';
import {
  TOP_PAGE_FILTER_TRACKING_TITLE,
  TopPageFilterFilterName,
  topPageFiltersTrackingFunction,
  TopPageFiltersTrackingFunctionParam,
} from '@utils/page-analytics/model/TopPageFiltersTracking';
import { GrowthDropdownOption, GrowthTypes } from './Types';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { PageName } from '@utils/pageConfig/Types';

interface ComparisonGrowthSelectorProps {
  growthOptions: ComparisonGrowth;
  isDisabled: boolean;
  selectedGrowthOption: any;
  growthOption: (e: any) => void;
}

const ComparisonGrowthSelector: React.FC<ComparisonGrowthSelectorProps> = ({
  growthOptions,
  isDisabled,
  selectedGrowthOption,
  growthOption,
}) => {
  const pagesConfig = usePageConfig();
  const { track } = useAnalytics();
  const retailerClientState = useSelector((state: any) => state.retailerClient);
  const sideFiltersState = useSelector((state: any) => state.sideFilters);
  const growthDropdownOptions: GrowthDropdownOption[] =
    growthOptions?.actual && growthOptions?.percentage
      ? [
          {
            value: GrowthTypes.percentage,
            label: growthOptions.percentage,
          },
          {
            value: GrowthTypes.actual,
            label: growthOptions.actual,
          },
        ]
      : [];

  const defaultGrowthValue: GrowthDropdownOption = growthDropdownOptions[0];

  const onChange = (e: any) => {
    const selectedOption = growthDropdownOptions.find((o) => o.value === e);
    //Starts top page amplitude tracking
    const trackingParam: TopPageFiltersTrackingFunctionParam = {
      eventTitle: TOP_PAGE_FILTER_TRACKING_TITLE,
      sideFilters: sideFiltersState.appliedFilters,
      track: track,
      filterType: FilterType.SELECTORS,
      filterName: TopPageFilterFilterName.COMPARE_IN,
      retailerClientState: retailerClientState,
      pageType: pagesConfig.pageType,
      pageName: pagesConfig.pageName,
      optionChosen: selectedOption?.label,
      access: pagesConfig.access,
    };

    topPageFiltersTrackingFunction(trackingParam);
    if (e !== selectedGrowthOption) {
      growthOption(e);
    }
  };

  return (
    <div className={pagesConfig.pageName === PageName.TRADING_ASSISTANT ? 'content-start' : 'content-end'}>
      <WithSelect
        id="comparison-growth-selector"
        name="comparison-growth-selector"
        label="Compare in"
        combobox={false} //default false now because growth option only consist of 2 parameter, if >= 5 then need set true
        options={growthDropdownOptions}
        disabled={isDisabled}
        value={selectedGrowthOption ?? defaultGrowthValue.value}
        onChange={onChange}
        {...{ hasSameValueOnClick: true }}
      />
    </div>
  );
};

export default ComparisonGrowthSelector;
